import { render, staticRenderFns } from "./NotificationDenied.vue?vue&type=template&id=3a0d4b03&"
import script from "./NotificationDenied.vue?vue&type=script&lang=js&"
export * from "./NotificationDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports